// Module
var code = `<!-- ko let: { question: survey.getAllQuestions()[0] } -->
  <!-- ko component: { name: survey.getElementWrapperComponentName(question), params: { componentData:  survey.getElementWrapperComponentData(question), templateData: { name: question.koElementType, data: question } } } -->
  <!-- /ko -->
<!-- /ko -->`;
// Exports
export default code;